/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentages are computed from the values automatically.`)
};

const es_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los porcentajes se calculan automáticamente a partir de los valores.`)
};

const de_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozentsätze werden automatisch aus den Werten berechnet.`)
};

const nl_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentages worden automatisch berekend uit de waarden.`)
};

const fr_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les pourcentages sont calculés automatiquement à partir des valeurs.`)
};

const it_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le percentuali vengono calcolate automaticamente dai valori.`)
};

const pt_br2_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os percentuais são calculados automaticamente a partir dos valores.`)
};

const pt_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As percentagens são calculadas automaticamente a partir dos valores.`)
};

const ja_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセンテージは値から自動的に計算されます。`)
};

const zh_pie_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比会根据数值自动计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_ex2", locale)
	if (locale === "en") return en_pie_ex2(inputs)
	if (locale === "es") return es_pie_ex2(inputs)
	if (locale === "de") return de_pie_ex2(inputs)
	if (locale === "nl") return nl_pie_ex2(inputs)
	if (locale === "fr") return fr_pie_ex2(inputs)
	if (locale === "it") return it_pie_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pie_ex2(inputs)
	if (locale === "pt") return pt_pie_ex2(inputs)
	if (locale === "ja") return ja_pie_ex2(inputs)
	return zh_pie_ex2(inputs)
};